import {useOutletContext} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {TabPanel, TabView} from "primereact/tabview";
import {Badge} from "primereact/badge";

export default function ClientReceipts() {

    const context = useOutletContext()
    const [receipts, setReceipts] = useState(context.receipts)
    const types = [
        {label: 'Детский клуб', id: 'kindergarten'},
        {label: 'Доп. занятия', id: 'additional_class'},
        {label: 'Индивидуальные', id: 'individual_lesson'},
        {label: 'Летний лагерь', id: 'summer_camp'},
        {label: 'Школа', id: 'school'}
    ]

    useEffect(() => {
        setReceipts(context.receipts)
    }, [context]);

    const rowTitle = (data) => {
        return <>
            <div dangerouslySetInnerHTML={{__html: data.table_comment}}></div>
        </>
    }

    const tabHeaderTemplate = (options, type) => {
        let counter = receipts.filter((el) => el.object_type === type.id).length;
        return (
            <div className={'p-tabview-nav-link'} onClick={options.onClick}>
                {type.label}

                {counter > 0 &&
                    <Badge value={counter} className={'m-l-10'}></Badge>
                }
            </div>
        )
    }

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <h3 className={'m-b-0'}>Платежи</h3>
                </div>
                <div className="card-body">

                    <TabView>
                        {types.map((type) => {

                            let c = receipts.filter((el) => el.object_type === type.id).length
                            let isDisabled = c > 0

                            return (
                                <TabPanel headerTemplate={(options) => tabHeaderTemplate(options, type)} disabled={!isDisabled}>
                                    <DataTable tableClassName={'table table-styling user-table'} value={receipts.filter((el) => el.object_type === type.id).reverse()}>
                                        <Column header={'Дата добавления'} field={'created_date'}></Column>
                                        <Column header={'Сумма'} field={'amount_public'}></Column>
                                        <Column header={'Назначение'} body={rowTitle}></Column>
                                    </DataTable>
                                </TabPanel>
                            )
                        })}


                    </TabView>


                </div>
            </div>
        </>
    )
}